import React, { Component } from 'react';

class getSubrubros extends Component {
  mostrarSubRubros = () => {
    const subrubros = this.props.subrubros;
    if(subrubros.length === 0) return null;
    //console.log("id_item");
    return (
      <React.Fragment>
        {subrubros.map(subrubro => (
          <button key={subrubro.id_subrubro} className="boton_subrubro" onClick={ () => this.props.datosBusquedaItem(subrubro.id_subrubro)}>{subrubro.subrubro}</button>
        ) ) }
      </React.Fragment>
    )
  }

  render() {

    let data;
        if (this.props.ok_subrubro===false) {
          data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ."  className="lbl_loading" src={ require('../images/loading.gif') } /></div>
          //console.log(this.props.ok_subrubro);
        } else {
          data = <React.Fragment>
                  {this.mostrarSubRubros()}
                </React.Fragment>
        }

    return (
      <div>
            {data}
       </div>
    );
  }
  componentDidUpdate (){
    const subrubros = this.props.subrubros;
    const id_subrubro = this.props.id_subrubro;
    let id_new_subrubro='';
    //console.log("___"+id_subrubro);

    if(subrubros.length === 0) return null;
    if(id_subrubro==='0'&&subrubros.length !== 0){
      for (var i = 0; i < subrubros.length; i++) {
        id_new_subrubro = subrubros[i].id_subrubro;
        break;
      }
      this.props.datosBusquedaItem(id_new_subrubro)
    }
  }
}
export default getSubrubros;
